import React from 'react';
import { connect } from 'react-redux';
import { DBTextAreaObjective, DBCheckBoxRadioComment } from '_components';
import styles from './Common.module.css'

class SpeechClinicalObservations extends React.Component {

    render() {
        return (
            <div>
                <div className={styles.commentTxt}>
                    <b>Comments</b>
                </div>

                <div className={styles.commentSection}>
                    <DBTextAreaObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVESPEECH'
                        entityKeyColumn='OSNO'
                        entityKeyValue={this.props.osno}
                        field='OSCLICOMMENTS'
                        className={styles.textarea}
                    />
                </div>
               
                <div className={styles.formRow}>
                <DBCheckBoxRadioComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVESPEECH'
                         entityKeyColumn='OSNO'
                         entityKeyValue={this.props.osno}
                         field= 'OSCLISOCIAL'
                         className={styles.checkbox}
                         label='Social Interaction'
                         textAreaStyle={styles.commentTextArea}
                         options={[{
                            id: 1,
                            label: 'WNL',
                            noteId: this.props.noteId,
                            entity: 'PTOBJECTIVESPEECH',
                            entityKeyColumn: 'OSNO',
                            entityKeyValue: this.props.osno,
                            field: 'OSCLISOCIALSTATUS',
                            selectedValue: 'WNL',
                            type: 'bit'
                          },
                          {
                            id: 2,
                            label: 'WFL',
                            noteId: this.props.noteId,
                            entity: 'PTOBJECTIVESPEECH',
                            entityKeyColumn: 'OSNO',
                            entityKeyValue: this.props.osno,
                            field: 'OSCLISOCIALSTATUS',
                            selectedValue: 'WFL',
                            type: 'bit'
                          },
                          {
                            id: 3,
                            label: 'Reduced',
                            noteId: this.props.noteId,
                            entity: 'PTOBJECTIVESPEECH',
                            entityKeyColumn: 'OSNO',
                            entityKeyValue: this.props.osno,
                            field: 'OSCLISOCIALSTATUS',
                            selectedValue: 'Reduced',
                            type: 'bit'
                          }
                        ]}
                    />
                </div>


                <div className={styles.formRow}>
                <DBCheckBoxRadioComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVESPEECH'
                         entityKeyColumn='OSNO'
                         entityKeyValue={this.props.osno}
                         field= 'OSCLIEYE'
                         className={styles.checkbox}
                         label='Eye Contact'
                         textAreaStyle={styles.commentTextArea}
                         options={[{
                            id: 1,
                            label: 'WNL',
                            noteId: this.props.noteId,
                            entity: 'PTOBJECTIVESPEECH',
                            entityKeyColumn: 'OSNO',
                            entityKeyValue: this.props.osno,
                            field: 'OSCLIEYESTATUS',
                            selectedValue: 'WNL',
                            type: 'bit'
                          },
                          {
                            id: 2,
                            label: 'Brief',
                            noteId: this.props.noteId,
                            entity: 'PTOBJECTIVESPEECH',
                            entityKeyColumn: 'OSNO',
                            entityKeyValue: this.props.osno,
                            field: 'OSCLIEYESTATUS',
                            selectedValue: 'Brief',
                            type: 'bit'
                          },
                          {
                            id: 3,
                            label: 'None',
                            noteId: this.props.noteId,
                            entity: 'PTOBJECTIVESPEECH',
                            entityKeyColumn: 'OSNO',
                            entityKeyValue: this.props.osno,
                            field: 'OSCLIEYESTATUS',
                            selectedValue: 'None',
                            type: 'bit'
                          }
                        ]}
                    />
                </div>


                <div className={styles.formRow}>
                <DBCheckBoxRadioComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVESPEECH'
                         entityKeyColumn='OSNO'
                         entityKeyValue={this.props.osno}
                         field= 'OSCLIATTENTION'
                         className={styles.checkbox}
                         label='Attention'
                         textAreaStyle={styles.commentTextArea}
                         options={[{
                            id: 1,
                            label: 'WNL',
                            noteId: this.props.noteId,
                            entity: 'PTOBJECTIVESPEECH',
                            entityKeyColumn: 'OSNO',
                            entityKeyValue: this.props.osno,
                            field: 'OSCLIATTENTIONSTATUS',
                            selectedValue: 'WNL',
                            type: 'bit'
                          },
                          {
                            id: 2,
                            label: 'Reduced',
                            noteId: this.props.noteId,
                            entity: 'PTOBJECTIVESPEECH',
                            entityKeyColumn: 'OSNO',
                            entityKeyValue: this.props.osno,
                            field: 'OSCLIATTENTIONSTATUS',
                            selectedValue: 'Reduced',
                            type: 'bit'
                          }
                        ]}
                    />
                </div>


                <div className={styles.formRow}>
                <DBCheckBoxRadioComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVESPEECH'
                         entityKeyColumn='OSNO'
                         entityKeyValue={this.props.osno}
                         field= 'OSCLIPOORSENS'
                         className={styles.checkbox}
                         label='Poor Sensory Integration'
                         textAreaStyle={styles.commentTextArea}
                    />
                </div>


                <div className={styles.formRow}>
                <DBCheckBoxRadioComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVESPEECH'
                         entityKeyColumn='OSNO'
                         entityKeyValue={this.props.osno}
                         field= 'OSCLISTIMULUS'
                         className={styles.checkbox}
                         label='Stimulus Fascination (lights, smells, etc.)'
                         textAreaStyle={styles.commentTextArea}
                    />
                </div>


                <div className={styles.formRow}>
                <DBCheckBoxRadioComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVESPEECH'
                         entityKeyColumn='OSNO'
                         entityKeyValue={this.props.osno}
                         field= 'OSCLICOMPLIANCE'
                         className={styles.checkbox}
                         label='Compliance'
                         textAreaStyle={styles.commentTextArea}
                         options={[{
                            id: 1,
                            label: 'WNL',
                            noteId: this.props.noteId,
                            entity: 'PTOBJECTIVESPEECH',
                            entityKeyColumn: 'OSNO',
                            entityKeyValue: this.props.osno,
                            field: 'OSCLICOMPLIANCESTATUS',
                            selectedValue: 'WNL',
                            type: 'bit'
                          },
                          {
                            id: 2,
                            label: 'Reduced',
                            noteId: this.props.noteId,
                            entity: 'PTOBJECTIVESPEECH',
                            entityKeyColumn: 'OSNO',
                            entityKeyValue: this.props.osno,
                            field: 'OSCLICOMPLIANCESTATUS',
                            selectedValue: 'Reduced',
                            type: 'bit'
                          }
                        ]}
                    />
                </div>


                <div className={styles.formRow}>
                <DBCheckBoxRadioComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVESPEECH'
                         entityKeyColumn='OSNO'
                         entityKeyValue={this.props.osno}
                         field= 'OSCLIAGGRESSION'
                         className={styles.checkbox}
                         label='Aggression'
                         textAreaStyle={styles.commentTextArea}
                    />
                </div>


                <div className={styles.formRow}>
                <DBCheckBoxRadioComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVESPEECH'
                         entityKeyColumn='OSNO'
                         entityKeyValue={this.props.osno}
                         field= 'OSCLIECHOLALIA'
                         className={styles.checkbox}
                         label='Echolalia'
                         textAreaStyle={styles.commentTextArea}
                    />
                </div>

                <div className={styles.formRow}>
                <DBCheckBoxRadioComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVESPEECH'
                         entityKeyColumn='OSNO'
                         entityKeyValue={this.props.osno}
                         field= 'OSCLIRITUAL'
                         className={styles.checkbox}
                         label='Ritual Speech'
                         textAreaStyle={styles.commentTextArea}
                    />
                </div>

                <div className={styles.formRow}>
                <DBCheckBoxRadioComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVESPEECH'
                         entityKeyColumn='OSNO'
                         entityKeyValue={this.props.osno}
                         field= 'OSCLIPLAY'
                         className={styles.checkbox}
                         label='Play Skills'
                         textAreaStyle={styles.commentTextArea}
                         options={[{
                            id: 1,
                            label: 'WNL',
                            noteId: this.props.noteId,
                            entity: 'PTOBJECTIVESPEECH',
                            entityKeyColumn: 'OSNO',
                            entityKeyValue: this.props.osno,
                            field: 'OSCLIPLAYSTATUS',
                            selectedValue: 'WNL',
                            type: 'bit'
                          },
                          {
                            id: 2,
                            label: 'Delayed',
                            noteId: this.props.noteId,
                            entity: 'PTOBJECTIVESPEECH',
                            entityKeyColumn: 'OSNO',
                            entityKeyValue: this.props.osno,
                            field: 'OSCLIPLAYSTATUS',
                            selectedValue: 'Delayed',
                            type: 'bit'
                          }
                        ]}
                    />
                </div>

                <div className={styles.formRow}>
                <DBCheckBoxRadioComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVESPEECH'
                         entityKeyColumn='OSNO'
                         entityKeyValue={this.props.osno}
                         field= 'OSCLISTEREO'
                         className={styles.checkbox}
                         label='Stereotyped / Repetitive Motor Mannerisms'
                         textAreaStyle={styles.commentTextArea}
                    />
                </div>
            </div>
        );
    }

}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let osno = parseInt(Object.keys(state.entities.notes.PTOBJECTIVESPEECH)
    .find(key => (state.entities.notes.PTOBJECTIVESPEECH[key].OSEVNO === pk && noteType === 1)
        || (state.entities.notes.PTOBJECTIVESPEECH[key].OSNTNO === pk && noteType !== 1)));
        
    return {
        noteId: noteId,
        osno: osno
    };
}

const connectedSpeechClinicalObservations = connect(mapStateToProps)(SpeechClinicalObservations);
export { connectedSpeechClinicalObservations as SpeechClinicalObservations };


